import React, { useState, useEffect } from "react";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight, } from "react-icons/md";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { ActionFormatterComponent, videoArtistFormatter, videoFormatter } from "../../../components/CommonMethod/CommonBoostrapFormatter";
import { artistDefaultURL } from "../../../components/CommonApis/CommonArtistApis";
import { adminApiHeader } from "../../../components/CommonApis/CommonApiUrl";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminHeader from "../../../components/CommonComponents/AdminHeader";
import { toast } from "react-toastify";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import NavigationData from "../../../layout/Sidebar/NavigationData";
import { getItem, getItemToken } from "../../../Utils/localStorageUtils";
import { donwloadCSV, downloadPDF, downloadXLSX, findUploadName } from "../../../components/CommonMethod/CommonMethods";
import { RxReload } from "react-icons/rx";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import { IoClose } from 'react-icons/io5';
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import { connect } from "react-redux";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";
import { useMyContext } from "../../../components/Provider/CommonProvider";

function AllArtist({ siteTheme }) {
  const { deleteImageFile } = useMyContext()
  // console.log(siteTheme)
  const BaseUrl = process.env.REACT_APP_Baseurl
  const languageApi = `${BaseUrl}/admin/User-Translate-Language`
  const userRole = getItem("role");
  const headers = getItemToken('access_token');
  const { label_management } = NavigationData();
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [artistTypes, setArtistTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [modelClose, setModelClose] = useState(false);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [filter, setFilter] = useState('');
  const [reloading, setReloading] = useState(false);
  const [languageCode, setLanguageCode] = useState('');

  useEffect(() => {
    if (siteTheme) {
      //console.log("siteTheme loaded:", siteTheme);
      //alert(siteTheme?.translate_checkout)
    }
  }, [siteTheme]);
  useEffect(() => {
    const fetchLanguageCode = async () => {
      try {
        const { data } = await axios.get(languageApi, { headers });
        if (data?.status) {
          const language = data?.Language_Code || 'en'; // fallback to 'en' or another default if needed
          setLanguageCode(language);
        } else {
          console.warn('Unexpected API response format:', data);
        }
      } catch (error) {
        const errorMsg = error?.response?.data?.message || error.message || 'Unknown error';
        console.error('Error fetching language code:', errorMsg);
      }
    };
    fetchLanguageCode();
  }, []);

  const fetchData = async (type) => {
    // setShowOverlay(true);
    setLoading(true);
    try {
      // First: Fetch Label Management data
      const labelResponse = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
        {
          headers: headers,
          params: { source: "add-artist" },
        }
      );
      setLabelDisplay(labelResponse?.data?.label_management || []);
    } catch (error) {
      console.error("Error fetching label display:", error);
    }

    let allArtistTypes = [];
    try {
      const typeResponse = await axios.get(`${BaseUrl}/admin/artist-category/index`, { headers });
      if (typeResponse?.data?.status) {
        allArtistTypes = typeResponse?.data?.allArtistCategory || [];
        setArtistTypes(allArtistTypes);
      }
    } catch (error) {
      console.error("Error fetching artist types:", error);
    }

    try {
      // Then: Fetch Artist List data
      const response = await axios.get(`${artistDefaultURL?.listApi}`, { headers });
      const result = response?.data?.[artistDefaultURL?.fetchArrayName];

      const updatedList = await Promise.all(result?.map(async (item) => {
        const UploadStatus = await findUploadName(item?.uploaded_by);
        const typeIds = String(item.artist_type || "").split(',');
        const mappedType = typeIds.map(id => {
          return allArtistTypes.find(t => String(t.id) === String(id))?.name || id;
        }).join(', ');
        return { ...item, uploaded_by: UploadStatus, artist_type: mappedType };
      }));

      if (type === "CSV") {
        await donwloadCSV(updatedList, "ARTIST-LIST");
      }
      if (type === "PDF") {
        await downloadPDF(updatedList, "ARTIST-LIST", ["INDEX", "ARTIST NAME", "ARTIST TYPE", "UPLOADED BY"]);
      }
      if (type === "XLSX") {
        await downloadXLSX(updatedList, "ARTIST-LIST", ["INDEX", "ARTIST NAME", "ARTIST TYPE", "UPLOADED BY"]);
      }
      setApiData(updatedList);
      setFilteredData(updatedList);
    } catch (error) {
      console.error("Error fetching artist data:", error);
    } finally {
      setLoading(false);
      setShowOverlay(false);
    }
  };

  //Bootstrap Table util start
  const columns = [
    {
      dataField: "artist_name",
      text: "Artist",
      formatter: (cell, row) => siteTheme ? videoArtistFormatter(cell, row, siteTheme, languageCode) : null,
      headerClasses: 'video-width-table'
    }

    ,
    {
      dataField: "artist_type",
      text: "Artist Type",
      formatter: (cell, row) => <MessageBox text={cell?.replaceAll("_", " ")} />
    },

    {
      dataField: "uploaded_by",
      text: "Upload by",
      //sort: true,
    },

    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) => <ActionFormatterComponent cell={cell} row={row} link={"/edit-artist/"} action={singleDelete} />,
    },
  ];
  const sizePerPageRenderer = ({ options, currSizePerPage, onSizePerPageChange }) => (
    <div className="btn-group" role="group">
      <select
        className="form-select custom-page-select"
        value={currSizePerPage}
        onChange={(e) => onSizePerPageChange(e.target.value)}
      >
        {options.map((opt) => (
          <option key={opt.page} value={opt.value}>
            {opt.text}
          </option>
        ))}
      </select>
    </div>
  );

  const options = {
    sizePerPageRenderer: sizePerPageRenderer, // if you have one
    paginationSize: 4,
    sizePerPage: 10,
    nextPageText: 'Next',
    prePageText: 'Prev',
    firstPageText: <span><MdKeyboardDoubleArrowLeft /></span>,
    lastPageText: <span><MdKeyboardDoubleArrowRight /></span>,
    showTotal: true,
    alwaysShowAllBtns: true,
  };
  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (row) {
        if (isSelect) {
          setItemToDelete([...itemToDelete, row.id]);
        } else {
          setItemToDelete(itemToDelete?.filter((id) => id !== row?.id));
        }
      }
    },
    style: { width: '50px' },
    selected: itemToDelete,
    selectionHeaderRenderer: ({ mode, checked }) => (
      <div>
        <input type="checkbox" checked={checked} onChange={handleAll} />
      </div>
    ),
  };

  const handleDeleteImage = async () => {
    await deleteImageFile(itemToDelete, "Artist");
  }

  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    await handleDeleteImage();
    try {
      const response = await axios.delete(`${artistDefaultURL?.MultiDeleteApi}`, {
        headers: headers,
        data: { [artistDefaultURL?.reqBodyName?.deleteName]: [...itemToDelete] },
      });
      const result = response?.data;
      if (result?.status) {
        setWithoutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setItemToDelete([])
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };

  // Api links end
  const closeModal = () => {
    setModelClose(!closeModal);
    setItemToDelete([]);
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };

  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };

  const handleAll = () => {
    setSelectAll(!selectAll);
    setItemToDelete(selectAll ? [] : filteredData?.map((item) => item?.id));
  };

  const handleFilter = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setFilter(searchTerm);
    if (searchTerm.trim() === '') {
      setFilteredData(apiData); // reset to full list
      return;
    }
    const filteredResults = apiData.filter((item) =>
      ["id", "name", "mobile", "email", "role", "title", "albumname", "artist_name", "artist_type", "uploaded_by"].some((property) =>
        typeof item[property] === "string" && item[property].toLowerCase().includes(searchTerm)) || (typeof item.id === "number" && item.id.toString().includes(searchTerm)));
    setFilteredData(filteredResults);
  };

  const handleClear = () => {
    setFilter('');
    setFilteredData(apiData); // reset to full list
  };

  const reloadAction = async () => {
    setReloading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      const typeResponse = await axios.get(`${BaseUrl}/admin/artist-category/index`, { headers });
      let allArtistTypes = [];
      if (typeResponse?.data?.status) {
        allArtistTypes = typeResponse?.data?.allArtistCategory || [];
        setArtistTypes(allArtistTypes);
      }

      const response = await axios.get(`${artistDefaultURL?.listApi}`, { headers });
      const result = response?.data?.[artistDefaultURL?.fetchArrayName];
      const updatedList = await Promise.all(result?.map(async (item) => {
        const UploadStatus = await findUploadName(item?.uploaded_by);
        const typeIds = String(item.artist_type || "").split(',');
        const mappedType = typeIds.map(id => {
          return allArtistTypes.find(t => String(t.id) === String(id))?.name || id;
        }).join(', ');
        return { ...item, uploaded_by: UploadStatus, artist_type: mappedType };
      }));
      setApiData(updatedList);
      setFilteredData(updatedList);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setReloading(false);
    }
  };


  useEffect(() => {
    fetchData();
  }, [withOutRefresh, siteTheme]);

  return (
    <>
      {showOverlay && <Response_Processing />}
      {modelClose && <AdminDeleteModal modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={itemToDelete?.length} />}
      <AdminNavbar heading={`All ${labelDisplay?.[12]?.title}`} totalDataLength={apiData?.length} deleteCount={itemToDelete?.length} navigation={artistDefaultURL?.addRouteLink} deleteMethod={openModal} navText={`Add ${labelDisplay?.[12]?.title}`} />
      <div className="theme-bg-color p-3 rounded-2 bootstrapTable multi-delete-width" >
        <div className='d-flex align-items-center flex-wrap justify-content-between mb-3'>
          <div className="filterContainer">
            <input type='text' id="filter-search" placeholder="Search the list " className="filter form-control theme-text-color theme-border-secondary  theme-bg-color-secondary" value={filter} onChange={(event) => handleFilter(event)} />
            {filter?.length > 0 && (<button type="button" className="clearBtn" onClick={() => handleClear()}  ><IoClose className="custom-close-btn" /> </button>)}
          </div>
          <div className='d-flex align-items-center'>
            <button id="reloadButton" className={`bg-transparent  custom-tool-tip-parent reloadButton theme-text-color p-2 me-2  border border-2 rounded-circle theme-border-color `} onClick={reloadAction}>
              <RxReload style={{ width: "18px", height: "15px" }} className={`${reloading ? "rotate-load" : ""}`} />
              <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />

            </button>
            {/* <div className="dropdown d-block ms-2" key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                <span className="fw-bolder text-white">Export</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportButton" >
                <li id="exportCSV" className="dropdown-item theme-text-color" onClick={() => fetchData("CSV")}>CSV</li>
                <li id="exportPDF" className="dropdown-item theme-text-color" onClick={() => fetchData("PDF")}>PDF</li>
                <li id="exportXLSX" className="dropdown-item theme-text-color" onClick={() => fetchData("XLSX")}>XLSX </li>
              </ul>
            </div> */}
            <div className="dropdown d-block ms-2 " key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportAllButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                <span className="fw-bolder text-white">Export All</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllButton" >
                <li id="exportallCSV" className="dropdown-item theme-text-color" onClick={() => fetchData("CSV", "ALL")}>CSV</li>
                <li id="exportallPDF" className="dropdown-item theme-text-color" onClick={() => fetchData("PDF", "ALL")}>PDF</li>
                <li id="exportallXLSX" className="dropdown-item theme-text-color" onClick={() => fetchData("XLSX", "ALL")}>XLSX </li>
              </ul>
            </div>
          </div>
        </div>

        <div style={{ position: 'relative' }}>
          {reloading && (
            <div style={{
              position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0.6)',
              display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10,
            }}><Defaultloadinggif />
            </div>
          )}
          <BootstrapTable keyField="id" id="All-artists" data={filteredData} columns={columns}
            pagination={paginationFactory(options)} className="no-border-table theme-text-color" noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />}
            hover headerClasses="videoWidth" selectRow={selectRow} selectAll={selectAll} />
        </div>
      </div>

    </>
  );
}
const mapStateToProps = (state) => ({
  siteTheme: state.siteTheme.siteTheme
});

export default connect(mapStateToProps)(AllArtist)